// Suche in der Objektauswahl des Serienmail-Assistenten.
//
// Wunsch aus dem Betrieb (Ticket Bjoern): die Objekte stehen als Knopfleiste da —
// bei rund 100 Liegenschaften sucht man sich darin dumm und duselig.
//
// Zwei Regeln, die nicht offensichtlich sind und deshalb hier und nicht in der
// Komponente stehen:
//   1. Ein bereits GEWAEHLTES Objekt bleibt immer sichtbar, auch wenn es nicht zum
//      Suchbegriff passt. Sonst waehlt man Fuldatal, tippt danach "Hasenkopf" und
//      glaubt, die Auswahl sei verlorengegangen.
//   2. Umlaute werden auf beiden Seiten gleich normalisiert — "buderusstrasse"
//      findet "Buderusstraße". Diese Schreibweisen mischen sich in Objektnamen.

interface ObjektMitNamen {
  id: string;
  bezeichnung: string;
}

function normalisiere(text: string): string {
  return text
    .toLowerCase()
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss');
}

export function filtereObjekte<T extends ObjektMitNamen>(
  objekte: T[],
  suche: string,
  ausgewaehlt: Set<string>,
): T[] {
  const begriff = normalisiere(suche.trim());
  if (begriff === '') return objekte;
  // Die Reihenfolge bleibt die der Liste (alphabetisch aus der Datenbank); die
  // gewaehlten werden also NICHT nach oben sortiert, damit die Knoepfe beim Tippen
  // nicht unter dem Mauszeiger wegspringen.
  return objekte.filter((o) => ausgewaehlt.has(o.id) || normalisiere(o.bezeichnung).includes(begriff));
}
